import React from 'react';

export const Lights: React.FC = () => {
    return (
        <>
            <ambientLight args={[0x404040]} intensity={3} />
        </>
    );
};
